import React from 'react'

import Cover from './Cover'
import ResumoEstrategico from './ResumoEstrategico'

const ResumoEstrategicoContent = ({ headerValues }) => {
  headerValues = {
    tipo: 'RESUMO EXECUTIVO',
    titulo: 'ANÁLISE DE RISCO',
    ...headerValues
  }

  return (
    <>
      <Cover headerValues={headerValues} />
      <ResumoEstrategico headerValues={headerValues} />
    </>
  )
}

export default ResumoEstrategicoContent
